import { List, ListItem, Typography, useTheme } from '@mui/material';
import DOMPurify from 'dompurify';

const additionalStyles = {
  ordered: { listStyle: 'decimal' },
  orderedSmall: { listStyle: 'decimal', ItemVariant: 'body2' },
  unordered: { listStyle: 'disc' },
  unorderedSmall: { listStyle: 'disc', ItemVariant: 'body2' },
};

const ContentList = props => {
  const theme = useTheme();
  return (
    <List
      sx={{
        ...additionalStyles[props.variant],
        pl: 3,
        listStyleType: props.isNested
          ? 'none'
          : additionalStyles[props.variant].listStyle,
      }}
    >
      {props.items.map((item, index) => (
        <ListItem
          sx={{
            display: 'list-item',
            p: 0,
            listStyleType:
              typeof item === 'object' && item.type === 'list'
                ? 'none'
                : additionalStyles[props.variant].listStyle,
          }}
          key={index}
        >
          {typeof item === 'object' && item.type === 'list' ? (
            <ContentList {...item} isNested={true} />
          ) : (
            <Typography
              variant={additionalStyles[props.variant]?.ItemVariant ?? 'body1'}
              sx={{
                '& a': {
                  color: theme.vars.palette.primary.main,
                },
              }}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(item, {
                  ALLOWED_ATTR: ['href', 'referrerpolicy', 'target'],
                }),
              }}
            />
          )}
        </ListItem>
      ))}
    </List>
  );
};

export default ContentList;
